var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 2a3 3 0 0 1 2.995 2.824L16 5v1h4a1 1 0 0 1 .117 1.993L20 8h-1v11a3 3 0 0 1-2.824 2.995L16 22H8a3 3 0 0 1-2.995-2.824L5 19V8H4a1 1 0 0 1-.117-1.993L4 6h4V5a3 3 0 0 1 2.824-2.995L11 2h2zm4 6H7v11a1 1 0 0 0 .883.993L8 20h8a1 1 0 0 0 .993-.883L17 19V8zm-7 3a1 1 0 0 1 .993.883L11 12v4a1 1 0 0 1-1.993.117L9 16v-4a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 .993.883L15 12v4a1 1 0 0 1-1.993.117L13 16v-4a1 1 0 0 1 1-1zm-1-7h-2a1 1 0 0 0-.993.883L10 5v1h4V5a1 1 0 0 0-.883-.993L13 4z",
    fill: "#4E5978",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRemove);
export default __webpack_public_path__ + "static/media/ico-remove.44f15fa0abdf95fc58330eade5725b16.svg";
export { ForwardRef as ReactComponent };